<mat-spinner *ngIf="booth === null"></mat-spinner>
<mat-card *ngIf="booth !== null">
  <mat-card-header>
    <mat-card-title-group>
      <mat-card-title>
                <span style="display: flex; align-items: center">

        {{booth.name}}
        <button (click)="edit()" mat-icon-button>
          <mat-icon>edit</mat-icon>
        </button>
                </span>
      </mat-card-title>
      <mat-card-subtitle>
        <span style="display: flex; align-items: center" routerLink="/players/{{booth.owner.uuid}}">
          Owned by&nbsp;
          <img src="https://mc-heads.net/avatar/{{booth.owner.uuid}}/20"> &nbsp;
          {{booth.owner.username}}
      </span>
      </mat-card-subtitle>
    </mat-card-title-group>
  </mat-card-header>
  <mat-card-content>
    <mat-tab-group>
      <mat-tab label="Info">
        <br>
        <h2>Description</h2>
        <p>
          {{boothInfo?.description || "No description found"}}
        </p>
        <h2>Socials</h2>
        <span *ngIf="hasSocials">
        <span *ngFor="let social of socials">
          <b>{{social.name}}:</b>&nbsp;<a target="_blank" [href]="parseLink(social.name, social.value)">{{parseLink(social.name, social.value)}}</a> <br>
          </span>
          <p>Contact Email: {{boothInfo?.contactEmail || "no email found!"}}</p>
        </span>
        <span *ngIf="!hasSocials">
          <p>
            No socials found
          </p>
        </span>

        <h2>Purchase Changes</h2>
        <span *ngFor="let change of purchaseHistory">
          <p>
            <b>{{ change.time }}:</b>
            <span *ngIf="change.change.reviewer">
              {{change.change.reviewer.username}} updated the state to {{change.change.state}}
            </span>
            <span *ngIf="!change.change.reviewer">
              State updated to {{change.change.state}}
            </span>
            <span *ngIf="change.change.message">
              with the message:
              <p><i>"{{change.change.message}}"</i></p>
            </span>
          </p>
        </span>

        <h2>Build Changes</h2>
        <span *ngFor="let change of approvalHistory">
          <p>
            <b>{{ change.time }}:</b>
            <span *ngIf="change.change.reviewer">
              {{change.change.reviewer.username}} updated the state to {{change.change.state}}
            </span>
            <span *ngIf="!change.change.reviewer">
              State updated to {{change.change.state}}
            </span>
            <span *ngIf="change.change.message">
              with message {{change.change.message}}
            </span>
          </p>
        </span>
      </mat-tab>
      <mat-tab label="Members">
    <table mat-table [dataSource]="booth.members">
      <ng-container matColumnDef="player">
        <th mat-header-cell *matHeaderCellDef>Player</th>
        <td mat-cell *matCellDef="let p" routerLink="/players/{{p.uuid}}">
          <span style="display: flex; align-items: center">
            <img src="https://mc-heads.net/avatar/{{p.uuid}}/20"> &nbsp;
            {{p.username}}
          </span>
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let p">
          <button (click)="remove(p)" mat-icon-button>
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row *matRowDef="let row; columns: columns"></tr>
    </table>
        <br>
          <b>Add new member</b>
          <br>
          <app-player-search (selectedPlayerEvent)="add($event)"></app-player-search>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
  <mat-card-actions>
    <button mat-button color="accent" (click)="this.openState('purchase', 'ACCEPTED')" *ngIf="booth.purchaseState.state === BoothPurchaseState.APPLIED">
      Accept Booth
    </button>
    <button mat-button color="warn" (click)="this.openState('purchase', 'REJECTED')" *ngIf="booth.purchaseState.state === BoothPurchaseState.APPLIED">
      Deny Booth
    </button>
    <button (click)="this.openState('purchase')" mat-button>
      Change Purchase State
    </button>
    <button (click)="this.openState('approval')" mat-button>
      Change Build State
    </button>
  </mat-card-actions>
  <mat-card-actions>
    <button mat-stroked-button color="primary" (click)="sendOpenedEmail()">
      Send "Booth Opened" Email
    </button>
  </mat-card-actions>
</mat-card>
